import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { HandsetLayoutComponent } from '@layouts/application/handset-layout/handset-layout.component';
import { WebLayoutComponent } from '@layouts/application/web-layout/web-layout.component';
import { ProfileComponent } from '@features/profile/profile.component';

import { StandardHeaderLayoutComponent } from '@layouts/headers/standard-header-layout/standard-header-layout.component';
import { TitleComponent } from '@shared/components/title/title.component';
import { MainMenuComponent } from '@shared/components/main-menu/main-menu.component';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HandsetLayoutComponent, ProfileComponent, StandardHeaderLayoutComponent, TitleComponent, WebLayoutComponent, MainMenuComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
  ]
})
export class AppComponent implements OnInit {

  private breakpointObserver = inject(BreakpointObserver);

  public title = 'Bruised Ears App';
  public isHandset: boolean = false;

  ngOnInit() { 
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => { 
      this.isHandset = state.matches; 
    }); 
      
    this.breakpointObserver .observe([ Breakpoints.Tablet, Breakpoints.Web, Breakpoints.WebLandscape ]).subscribe((state: BreakpointState) => { 
      this.isHandset = !state.matches; 
    });
  }

}
